import React from 'react'


const Header = () => (
  <header className='mb3 h5'>
    <div>♥️♠️♦️♣️️</div>
    <h1 className='m0 h2'>Hi-Lo Practice</h1>
    <p className='m0'>
      Hi-Lo is a simple card counting system used in blackjack.
      It assigns a value of +1, 0, or -1 for every card that's played:
      2-6 → +1, 7-9 → 0, 10-A → -1.
    </p>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js